/* eslint-disable quotes */
export const countries = [
  { name: "Afghanistan", code: "AF", dial_code: "+93", mask: "XX XXX XXXX" },
  { name: "Albania", code: "AL", dial_code: "+355", mask: "XXX XXX XXXX" },
  { name: "Algeria", code: "DZ", dial_code: "+213", mask: "XXX XXX XXXX" },
  { name: "American Samoa", code: "AS", dial_code: "+1684", mask: "(XXX) XXX XXXX" },
  { name: "Andorra", code: "AD", dial_code: "+376", mask: "XXX XXX" },
  { name: "Angola", code: "AO", dial_code: "+244", mask: "XXX XXX XXX" },
  { name: "Argentina", code: "AR", dial_code: "+54", mask: "XX XXXX XXXX" },
  { name: "Armenia", code: "AM", dial_code: "+374", mask: "XX XXX XXX" },
  { name: "Australia", code: "AU", dial_code: "+61", mask: "X XXXX XXXX" },
  { name: "Austria", code: "AT", dial_code: "+43", mask: "XXXX XXXXX" },
  { name: "Azerbaijan", code: "AZ", dial_code: "+994", mask: "XX XXX XX XX" },
  { name: "Bahamas", code: "BS", dial_code: "+1242", mask: "(XXX) XXX XXXX" },
  { name: "Bahrain", code: "BH", dial_code: "+973", mask: "XXXX XXXX" },
  { name: "Bangladesh", code: "BD", dial_code: "+880", mask: "XXXXX XXXXX" },
  { name: "Barbados", code: "BB", dial_code: "+1246", mask: "(XXX) XXX XXXX" },
  { name: "Belarus", code: "BY", dial_code: "+375", mask: "XX XXX XXXX" },
  { name: "Belgium", code: "BE", dial_code: "+32", mask: "XXX XX XX XX" },
  { name: "Belize", code: "BZ", dial_code: "+501", mask: "XXX XXXX" },
  { name: "Benin", code: "BJ", dial_code: "+229", mask: "XX XX XX XX" },
  { name: "Bhutan", code: "BT", dial_code: "+975", mask: "XX XX XXXX" },
  { name: "Bolivia", code: "BO", dial_code: "+591", mask: "X XXX XXXX" },
  { name: "Bosnia", code: "BA", dial_code: "+387", mask: "XX XXX XXX" },
  { name: "Botswana", code: "BW", dial_code: "+267", mask: "XXX XXX XXX" },
  { name: "Brazil", code: "BR", dial_code: "+55", mask: "(XX) XXXXX XXXX" },
  { name: "Brunei", code: "BN", dial_code: "+673", mask: "XXX XXXX" },
  { name: "Bulgaria", code: "BG", dial_code: "+359", mask: "XXX XXX XXX" },
  { name: "Cambodia", code: "KH", dial_code: "+855", mask: "XX XXX XXX" },
  { name: "Cameroon", code: "CM", dial_code: "+237", mask: "XXXX XXXX" },
  { name: "Canada", code: "CA", dial_code: "+1", mask: "(XXX) XXX XXXX" },
  { name: "Chile", code: "CL", dial_code: "+56", mask: "X XXXX XXXX" },
  { name: "China", code: "CN", dial_code: "+86", mask: "XXX XXXX XXXX" },
  { name: "Colombia", code: "CO", dial_code: "+57", mask: "XXX XXX XXXX" },
  { name: "Costa Rica", code: "CR", dial_code: "+506", mask: "XXXX XXXX" },
  { name: "Croatia", code: "HR", dial_code: "+385", mask: "XX XXX XXXX" },
  { name: "Cyprus", code: "CY", dial_code: "+357", mask: "XXXX XXXX" },
  { name: "Czech Republic", code: "CZ", dial_code: "+420", mask: "XXX XXX XXX" },
  { name: "Denmark", code: "DK", dial_code: "+45", mask: "XX XX XX XX" },
  { name: "Dominican Republic", code: "DO", dial_code: "+1", mask: "(XXX) XXX XXXX" },
  { name: "Ecuador", code: "EC", dial_code: "+593", mask: "XX XXX XXXX" },
  { name: "Egypt", code: "EG", dial_code: "+20", mask: "XXX XXX XXXX" },
  { name: "El Salvador", code: "SV", dial_code: "+503", mask: "XXXX XXXX" },
  { name: "Estonia", code: "EE", dial_code: "+372", mask: "XXXX XXXX" },
  { name: "Ethiopia", code: "ET", dial_code: "+251", mask: "XX XXX XXXX" },
  { name: "Finland", code: "FI", dial_code: "+358", mask: "XX XXX XXXX" },
  { name: "France", code: "FR", dial_code: "+33", mask: "X XX XX XX XX" },
  { name: "Germany", code: "DE", dial_code: "+49", mask: "XXXX XXXXXXX" },
  { name: "Ghana", code: "GH", dial_code: "+233", mask: "XXX XXX XXXX" },
  { name: "Greece", code: "GR", dial_code: "+30", mask: "XXX XXX XXXX" },
  { name: "Guatemala", code: "GT", dial_code: "+502", mask: "XXXX XXXX" },
  { name: "Hong Kong", code: "HK", dial_code: "+852", mask: "XXXX XXXX" },
  { name: "Hungary", code: "HU", dial_code: "+36", mask: "XX XXX XXXX" },
  { name: "Iceland", code: "IS", dial_code: "+354", mask: "XXX XXXX" },
  { name: "India", code: "IN", dial_code: "+91", mask: "XXXXX XXXXX" },
  { name: "Indonesia", code: "ID", dial_code: "+62", mask: "XXX XXXX XXXX" },
  { name: "Iran", code: "IR", dial_code: "+98", mask: "XXX XXX XXXX" },
  { name: "Iraq", code: "IQ", dial_code: "+964", mask: "XXX XXX XXXX" },
  { name: "Ireland", code: "IE", dial_code: "+353", mask: "XX XXX XXXX" },
  { name: "Israel", code: "IL", dial_code: "+972", mask: "XX XXX XXXX" },
  { name: "Italy", code: "IT", dial_code: "+39", mask: "XXX XXX XXXX" },
  { name: "Japan", code: "JP", dial_code: "+81", mask: "XX XXXX XXXX" },
  { name: "Jordan", code: "JO", dial_code: "+962", mask: "XX XXXX XXXX" },
  { name: "Kenya", code: "KE", dial_code: "+254", mask: "XXX XXX XXX" },
  { name: "Korea South", code: "KR", dial_code: "+82", mask: "XXX XXXX XXXX" },
  { name: "Kuwait", code: "KW", dial_code: "+965", mask: "XXXX XXXX" },
  { name: "Latvia", code: "LV", dial_code: "+371", mask: "XXXX XXXX" },
  { name: "Lebanon", code: "LB", dial_code: "+961", mask: "XX XXX XXX" },
  { name: "Lithuania", code: "LT", dial_code: "+370", mask: "XXX XXXXX" },
  { name: "Luxembourg", code: "LU", dial_code: "+352", mask: "XXX XXX XXX" },
  { name: "Malaysia", code: "MY", dial_code: "+60", mask: "XXX XXX XXXX" },
  { name: "Mexico", code: "MX", dial_code: "+52", mask: "XXX XXX XXXX" },
  { name: "Morocco", code: "MA", dial_code: "+212", mask: "XXX XXX XXX" },
  { name: "Myanmar", code: "MM", dial_code: "+95", mask: "XX XXX XXX" },
  { name: "Nepal", code: "NP", dial_code: "+977", mask: "XXX XXX XXXX" },
  { name: "Netherlands", code: "NL", dial_code: "+31", mask: "XX XXX XXXX" },
  { name: "New Zealand", code: "NZ", dial_code: "+64", mask: "XX XXX XXXX" },
  { name: "Nigeria", code: "NG", dial_code: "+234", mask: "XXX XXX XXXX" },
  { name: "Norway", code: "NO", dial_code: "+47", mask: "XXXX XXXX" },
  { name: "Oman", code: "OM", dial_code: "+968", mask: "XXXX XXXX" },
  { name: "Pakistan", code: "PK", dial_code: "+92", mask: "XXX XXX XXXX" },
  { name: "Panama", code: "PA", dial_code: "+507", mask: "XXXX XXXX" },
  { name: "Paraguay", code: "PY", dial_code: "+595", mask: "XXX XXX XXX" },
  { name: "Peru", code: "PE", dial_code: "+51", mask: "XXX XXX XXX" },
  { name: "Philippines", code: "PH", dial_code: "+63", mask: "XXXX XXXX" },
  { name: "Poland", code: "PL", dial_code: "+48", mask: "XXX XXX XXX" },
  { name: "Portugal", code: "PT", dial_code: "+351", mask: "XXX XXX XXX" },
  { name: "Qatar", code: "QA", dial_code: "+974", mask: "XXXX XXXX" },
  { name: "Romania", code: "RO", dial_code: "+40", mask: "XXX XXX XXX" },
  { name: "Russia", code: "RU", dial_code: "+7", mask: "XXX XXX XX XX" },
  { name: "Saudi Arabia", code: "SA", dial_code: "+966", mask: "XX XXX XXXX" },
  { name: "Serbia", code: "RS", dial_code: "+381", mask: "XX XXX XXXX" },
  { name: "Singapore", code: "SG", dial_code: "+65", mask: "XXXX XXXX" },
  { name: "Slovakia", code: "SK", dial_code: "+421", mask: "XXX XXX XXX" },
  { name: "Slovenia", code: "SI", dial_code: "+386", mask: "XX XXX XXX" },
  { name: "South Africa", code: "ZA", dial_code: "+27", mask: "XXX XXX XXXX" },
  { name: "Spain", code: "ES", dial_code: "+34", mask: "XXX XXX XXX" },
  { name: "Sri Lanka", code: "LK", dial_code: "+94", mask: "XX XXX XXXX" },
  { name: "Sweden", code: "SE", dial_code: "+46", mask: "XXX XXX XXX" },
  { name: "Switzerland", code: "CH", dial_code: "+41", mask: "XX XXX XXXX" },
  { name: "Taiwan", code: "TW", dial_code: "+886", mask: "XXX XXXX" },
  { name: "Tanzania", code: "TZ", dial_code: "+255", mask: "XXX XXX XXX" },
  { name: "Thailand", code: "TH", dial_code: "+66", mask: "XX XXX XXXX" },
  { name: "Turkey", code: "TR", dial_code: "+90", mask: "XXX XXX XXXX" },
  { name: "Uganda", code: "UG", dial_code: "+256", mask: "XXX XXX XXX" },
  { name: "Ukraine", code: "UA", dial_code: "+380", mask: "XX XXX XXXX" },
  { name: "United Arab Emirates", code: "AE", dial_code: "+971", mask: "XX XXX XXXX" },
  { name: "United Kingdom", code: "GB", dial_code: "+44", mask: "XXXX XXX XXX" },
  { name: "United States", code: "US", dial_code: "+1", mask: "(XXX) XXX XXXX" },
  { name: "Uruguay", code: "UY", dial_code: "+598", mask: "XXX XXX XXX" },
  { name: "Uzbekistan", code: "UZ", dial_code: "+998", mask: "XX XXX XXXX" },
  { name: "Venezuela", code: "VE", dial_code: "+58", mask: "XXX XXX XXXX" },
  { name: "Vietnam", code: "VN", dial_code: "+84", mask: "XXX XXXX XXX" },
  { name: "Yemen", code: "YE", dial_code: "+967", mask: "XXX XXX XXX" },
  { name: "Zambia", code: "ZM", dial_code: "+260", mask: "XXX XXX XXX" },
  { name: "Zimbabwe", code: "ZW", dial_code: "+263", mask: "XXX XXX XXX" },
];
